import { BitfPaginationApiRequestPart } from '@bitf/core/api-call-state/bitf-pagination-api-request-part.builder';

export class BitfStrapiPaginationApiRequestPart extends BitfPaginationApiRequestPart {}
